import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import TopicWall from "./components/TopicWall";
import HeatBoard from "./components/HeatBoard";
import Exclusives from "./components/Exclusives";
import DailyFeed from "./components/DailyFeed";
import EditorNote from "./components/EditorNote";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <Masthead />
      <main>
        <Hero />
        <TopicWall />
        <HeatBoard />
        <Exclusives />
        <DailyFeed />
        <EditorNote />
      </main>
      <Footer />
    </div>
  );
}